"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthApi = exports.RequestError = void 0;
var Bcrypt = __importStar(require("bcryptjs"));
var recaptcha_1 = require("../recaptcha");
var utils_1 = require("../utils");
var signer_1 = require("./signer");
var RequestError = /** @class */ (function () {
    function RequestError(message, code) {
        this.message = message;
        this.code = code;
    }
    return RequestError;
}());
exports.RequestError = RequestError;
var AuthApi = /** @class */ (function () {
    function AuthApi(edenURL, recaptchaSiteKey, clientId, clientKey) {
        var _this = this;
        this.edenURL = edenURL;
        this.recaptchaSiteKey = recaptchaSiteKey;
        this.clientId = clientId;
        this.clientKey = clientKey;
        /**
         * Performs the request to Eden Auth API
         *
         * @returns a json object with the response payload
         * @param payload
         * @param options
         */
        this.makeRequest = function (payload, options) { return __awaiter(_this, void 0, void 0, function () {
            var timestamp, nonce, context, headers, token, usePreviousSignature, reqSignature, response, _a, signature;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        timestamp = (0, utils_1.getTimestamp)();
                        nonce = (0, signer_1.generateNonce)();
                        context = { timestamp: timestamp, nonce: nonce };
                        headers = {
                            'Content-Type': 'application/json; charset=utf-8',
                            'gc-app-name': 'web',
                            'gc-app-version': '0.0.0',
                        };
                        token = (_b = options === null || options === void 0 ? void 0 : options.token) === null || _b === void 0 ? void 0 : _b.data;
                        usePreviousSignature = (_c = options === null || options === void 0 ? void 0 : options.usePreviousSignature) !== null && _c !== void 0 ? _c : true;
                        if (this.previousSignature && usePreviousSignature) {
                            context.previousSignature = this.previousSignature;
                        }
                        return [4 /*yield*/, (0, signer_1.signPayload)(this.clientKey, context, payload)];
                    case 1:
                        reqSignature = _e.sent();
                        headers['gc-signature'] = "".concat(nonce, ".").concat(reqSignature);
                        headers['gc-client-id'] = this.clientId;
                        headers['gc-timestamp'] = "".concat(timestamp);
                        if (this.deviceId) {
                            headers['gc-device-id'] = this.deviceId;
                        }
                        if (token)
                            headers['gc-token'] = token;
                        return [4 /*yield*/, fetch("".concat(this.edenURL, "/auth"), {
                                method: 'POST',
                                body: JSON.stringify(payload),
                                headers: headers,
                                mode: 'cors',
                            })];
                    case 2:
                        response = _e.sent();
                        if (response.status >= 400) {
                            throw new RequestError('An error happened during the request.', response.status);
                        }
                        _a = ((_d = response.headers.get('gc-signature')) !== null && _d !== void 0 ? _d : '').split('.'), signature = _a[1];
                        this.previousSignature = signature;
                        return [2 /*return*/, response.json()];
                }
            });
        }); };
        /**
         * Sends out the client authentication request
         */
        this.authenticateClient = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ type: 'client-auth', client_id: this.clientId }, { usePreviousSignature: false })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, {
                                data: response['token'],
                                expires: response['expires'],
                            }];
                }
            });
        }); };
        /**
         * Request an email with authentication token to the backend
         *
         * @param email
         * @param redirectLink if given, will cause the generated login email to have a login link that will take the user to redirectLink
         */
        this.requestAuthenticationEmail = function (email, redirectLink, callbacks) { return __awaiter(_this, void 0, void 0, function () {
            var clientToken, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticateClient()];
                    case 1:
                        clientToken = _a.sent();
                        return [4 /*yield*/, this.makeRequest({ type: 'login-token', email: email, reason: 'required_login', deliver: 'email', redirectLink: redirectLink }, { token: clientToken })];
                    case 2:
                        response = _a.sent();
                        if (!(response['type'] === 'attestation-required')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.sendAttestation(clientToken, callbacks)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response['type'] === 'ok'];
                }
            });
        }); };
        /**
         * Logins the user using the auth token
         *
         * @param token
         */
        this.loginWithToken = function (token) { return __awaiter(_this, void 0, void 0, function () {
            var clientToken, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticateClient()];
                    case 1:
                        clientToken = _a.sent();
                        return [4 /*yield*/, this.makeRequest({ type: 'token-auth', token: token }, { token: clientToken })];
                    case 2:
                        response = _a.sent();
                        if (!(response['type'] === 'attestation-required')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.sendAttestation(clientToken)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (response['type'] === 'token') {
                            return [2 /*return*/, {
                                    accessToken: response['access'],
                                    refreshToken: response['refresh'],
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Finish Registration for a user
         */
        this.finishRegistration = function (_a) {
            var state = _a.state, token = _a.token, code = _a.code, password = _a.password, firstName = _a.firstName, lastName = _a.lastName, callbacks = _a.callbacks;
            return __awaiter(_this, void 0, void 0, function () {
                var response;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            response = state;
                            if (!(response['type'] === 'user-action-required' && response['kind'] === 'mfa')) return [3 /*break*/, 2];
                            (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onBeforeUserActionRequired) === null || _b === void 0 ? void 0 : _b.call(callbacks, 'mfa');
                            return [4 /*yield*/, this.sendMFACode(code, token)];
                        case 1:
                            response = _c.sent();
                            if (response['type'] === 'user-action-required' && response['kind'] === 'mfa') {
                                // Need to return for user to update MFA Code
                                return [2 /*return*/, response];
                            }
                            _c.label = 2;
                        case 2:
                            if (!(response['type'] === 'registration-required')) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.makeRequest({
                                    type: 'registration',
                                    password: password,
                                    personal_details: {
                                        first_name: firstName,
                                        last_name: lastName,
                                    },
                                }, { token: token })];
                        case 3:
                            response = _c.sent();
                            _c.label = 4;
                        case 4:
                            if (!(response['type'] === 'attestation-required')) return [3 /*break*/, 6];
                            return [4 /*yield*/, this.sendAttestation(token, callbacks)];
                        case 5:
                            response = _c.sent();
                            _c.label = 6;
                        case 6:
                            if (response['type'] === 'token') {
                                return [2 /*return*/, {
                                        type: 'logged-in',
                                        tokens: {
                                            accessToken: response['access'],
                                            refreshToken: response['refresh'],
                                        },
                                    }];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.startLoginOrRegistration = function (email) { return __awaiter(_this, void 0, void 0, function () {
            var clientToken, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticateClient()];
                    case 1:
                        clientToken = _a.sent();
                        return [4 /*yield*/, this.makeRequest({ type: 'user-auth', email: email }, { token: clientToken })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, { response: response, token: clientToken }];
                }
            });
        }); };
        /**
         * Continues from state created by startLoginOrRegistration method
         * Logins the user using email and password
         */
        this.finishLogInWithEmail = function (_a) {
            var state = _a.state, token = _a.token, password = _a.password, code = _a.code, callbacks = _a.callbacks;
            return __awaiter(_this, void 0, void 0, function () {
                var response;
                var _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            response = state;
                            if (!(response['type'] === 'user-action-required' && response['kind'] === 'mfa')) return [3 /*break*/, 2];
                            (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onBeforeUserActionRequired) === null || _b === void 0 ? void 0 : _b.call(callbacks, 'mfa-retry');
                            return [4 /*yield*/, this.sendMFACode(code, token)];
                        case 1:
                            response = _e.sent();
                            if (response['type'] === 'user-action-required' && response['kind'] === 'mfa') {
                                // Need to return for user to update MFA Code
                                return [2 /*return*/, response];
                            }
                            _e.label = 2;
                        case 2:
                            if (!(response['type'] === 'password-required')) return [3 /*break*/, 4];
                            (_c = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onBeforePasswordRequired) === null || _c === void 0 ? void 0 : _c.call(callbacks);
                            return [4 /*yield*/, this.sendPassword(password, response, token)];
                        case 3:
                            response = _e.sent();
                            _e.label = 4;
                        case 4:
                            if (response['type'] === 'user-action-required' && response['kind'] === 'time_otp') {
                                (_d = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onBeforeUserActionRequired) === null || _d === void 0 ? void 0 : _d.call(callbacks, 'time_otp');
                                return [2 /*return*/, {
                                        type: 'mfa',
                                        token: token,
                                    }];
                            }
                            if (!(response['type'] === 'attestation-required')) return [3 /*break*/, 6];
                            return [4 /*yield*/, this.sendAttestation(token, callbacks)];
                        case 5:
                            response = _e.sent();
                            _e.label = 6;
                        case 6:
                            if (response['type'] === 'token') {
                                return [2 /*return*/, {
                                        type: 'logged-in',
                                        tokens: {
                                            accessToken: response['access'],
                                            refreshToken: response['refresh'],
                                        },
                                    }];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.requestForgotPasswordToken = function (email, redirectLink, callbacks) { return __awaiter(_this, void 0, void 0, function () {
            var clientToken, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticateClient()];
                    case 1:
                        clientToken = _a.sent();
                        return [4 /*yield*/, this.makeRequest({
                                type: 'login-token',
                                email: email,
                                reason: 'forgot_password',
                                deliver: 'email',
                                redirectLink: redirectLink,
                            }, { token: clientToken })];
                    case 2:
                        response = _a.sent();
                        if (!(response.type === 'attestation-required')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.sendAttestation(clientToken, callbacks)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (response.type !== 'ok') {
                            throw new Error('An error occurred trying to request forgot password token');
                        }
                        return [2 /*return*/, clientToken];
                }
            });
        }); };
        this.requestChangePassword = function (newPassword, token, redirectLink, callbacks) { return __awaiter(_this, void 0, void 0, function () {
            var clientToken, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticateClient()];
                    case 1:
                        clientToken = _a.sent();
                        return [4 /*yield*/, this.makeRequest({
                                type: 'token-auth',
                                token: token,
                                redirectLink: redirectLink,
                            }, { token: clientToken })];
                    case 2:
                        response = _a.sent();
                        if (!(response.type === 'attestation-required')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.sendAttestation(clientToken, callbacks)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.makeRequest({ type: 'change-password', new_password: newPassword }, { token: clientToken, usePreviousSignature: false })];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.provideMFAVerificationCode = function (state, code) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(state.type === 'mfa')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.makeRequest({ type: 'user-action', data: code }, { token: state.token })];
                    case 1:
                        response = _a.sent();
                        if (response['type'] === 'token') {
                            return [2 /*return*/, {
                                    accessToken: response['access'],
                                    refreshToken: response['refresh'],
                                }];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Updates the refresh token
         * @param refreshToken
         */
        this.refreshTokens = function (refreshToken) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ type: 'refresh' }, { token: refreshToken, usePreviousSignature: false })];
                    case 1:
                        response = _a.sent();
                        if (response['type'] === 'token') {
                            return [2 /*return*/, {
                                    accessToken: response['access'],
                                    refreshToken: response['refresh'],
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Logout the user
         */
        this.logOut = function (token) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ type: 'logout' }, { usePreviousSignature: false, token: token })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Sends the password request for either User registration or authentication process
         *
         * @param password
         * @param responsePayload Previous response for 'password-required' step
         * @param token
         */
        this.sendPassword = function (password, responsePayload, token) { return __awaiter(_this, void 0, void 0, function () {
            var passwordParams, challengeParams, encPassword;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        passwordParams = responsePayload['password_params'];
                        challengeParams = responsePayload['challenge_params'];
                        encPassword = password;
                        if (passwordParams &&
                            challengeParams &&
                            passwordParams['alg'] === 'bcrypt' &&
                            challengeParams['alg'] === 'bcrypt') {
                            encPassword = Bcrypt.hashSync(encPassword, passwordParams.salt);
                            encPassword = Bcrypt.hashSync(encPassword, challengeParams.salt);
                        }
                        return [4 /*yield*/, this.makeRequest({ type: 'password', password: encPassword }, { token: token })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
         * Sends the attestation request
         *
         * @param token
         * @param callbacks Optional callbacks to be called before and after the attestation request
         */
        this.sendAttestation = function (token, callbacks) { return __awaiter(_this, void 0, void 0, function () {
            var recaptchaToken, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onBeforeAttestationRequired) === null || _a === void 0 ? void 0 : _a.call(callbacks);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, recaptcha_1.getRecaptchaToken)(this.recaptchaSiteKey)];
                    case 2:
                        recaptchaToken = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onRecaptchaTokenFailure) === null || _b === void 0 ? void 0 : _b.call(callbacks, error_1);
                        throw error_1;
                    case 4:
                        (_c = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onRecaptchaTokenSuccess) === null || _c === void 0 ? void 0 : _c.call(callbacks);
                        return [4 /*yield*/, this.makeRequest({ type: 'attestation', attestation: recaptchaToken }, { token: token })];
                    case 5: return [2 /*return*/, _d.sent()];
                }
            });
        }); };
        this.sendMFACode = function (code, token, usePreviousSignature) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.makeRequest({
                        type: 'mfa-code',
                        code: code,
                    }, { token: token, usePreviousSignature: usePreviousSignature })];
            });
        }); };
    }
    AuthApi.prototype.setDeviceId = function (deviceId) {
        this.deviceId = deviceId;
    };
    return AuthApi;
}());
exports.AuthApi = AuthApi;
